"use strict";
module.exports = {
    ACCIDENT_FORM: '/forms/accident-form.pdf',
    AHM_FUND_RULES: '/help/ahm-fund-rules.pdf',
    AMBULANCE_COVER_APPLICATION_FORM: '/forms/ambulance-cover-application-form.pdf',
    AUSTRALIAN_GOVERNMENT_REBATE_FORM: '/forms/australian-government-rebate-on-private-health-insurance-form.pdf',
    CLAIMS_AND_INFORMATION_CONSENT_FORM: '/forms/claims-and-information-consent-form.pdf',
    CLAIM_FORM: '/forms/claim-form.pdf',
    COCHLEAR_SPEECH_PROCESSOR_REPLACEMENT_FUNDING_FORM: '/forms/cochlear-speech-processor-replacement-funding-form.pdf',
    FINANCIAL_HARDSHIP_FORM: '/forms/financial-hardship-form.pdf',
    GAPCOVER_APPLICATION_FORM: '/forms/gapcover-application-form.pdf',
    GOING_TO_HOSPITAL: '/help/going-to-hospital.pdf',
    HEALTH_IMPROVEMENT_BENEFITS_APPROVAL: '/forms/health-improvement-benefits-approval.pdf',
    INFORMED_FINANCIAL_CONSENT: '/help/informed-financial-consent.pdf',
    INSULIN_PUMP_REPLACEMENT_FUNDING_FORM: '/forms/insulin-pump-replacement-funding-form.pdf',
    JOINT_COMPENSATION_CLAIM_FORM: '/forms/joint-compensation-claim-form.pdf',
    LHC_EXEMPTION_FORM: '/forms/lhc-exemption-form.pdf',
    LIFE_INSURANCE_ACCIDENTAL_DEATH_PRODUCT_DISCLOSURE: '/life-insurance/ahm-accidental-death-insurance-pds.pdf',
    LIFE_INSURANCE_BENEFICIARY_NOMINATION: '/life-insurance/ahm-nomination-of-beneficiary-form.pdf',
    LIFE_INSURANCE_EXPRESS_KEY_FACT_SHEET: '/life-insurance/ahm-life-insurance-express-kfs.pdf',
    LIFE_INSURANCE_EXPRESS_PRODUCT_DISCLOSURE: '/life-insurance/ahm-life-insurance-express-pds.pdf',
    LIFE_INSURANCE_FINANCIAL_SERVICES_GUIDE: '/life-insurance/ahm-financial-services-guide.pdf',
    LIFE_INSURANCE_INCOME_PROTECTION_PRODUCT_DISCLOSURE: '/life-insurance/ahm-life-insurance-income-protection-pds.pdf',
    LIFE_INSURANCE_PRIVACY_COLLECTION_NOTICED: '/life-insurance/privacy-collection-notice.pdf',
    LIFE_INSURANCE_PRODUCT_DISCLOSURE: '/life-insurance/ahm-life-insurance-pds.pdf',
    LIFE_INSURANCE_PRODUCT_DISCLOSURE_JULY: '/life-insurance/ahm-life-insurance-pds-july.pdf',
    MEDIA_RELEASE_2016_02_26: '/media/media-release-26-feb-2016.pdf',
    MEDICARE_CLAIMS_HISTORY_EXAMPLE: '/images/medicare/claims-history-example.png',
    MEDICARE_CLAIM_FORM: '/forms/medicare-claim-form.pdf',
    MEDICARE_STATEMENT_OF_BENEFIT_EXAMPLE_1: '/images/medicare/statement-of-benefit-example-1.png',
    MEDICARE_STATEMENT_OF_BENEFIT_EXAMPLE_2: '/images/medicare/statement-of-benefit-example-2.png',
    MEDICARE_STATEMENT_OF_CLAIM_EXAMPLE: '/images/medicare/statement-of-claim-example.png',
    MEDICARE_TWO_WAY_CLAIM_FORM: '/forms/medicare-two-way-claim-form.pdf',
    MEMBER_GUIDE: '/help/member-guide.pdf',
    PAYMENT_FORM: '/forms/payment-form.pdf',
    PRE_EXISTING_CONDITIONS_FORM: '/forms/phi-pec-forms.pdf',
    THIRD_PARTY_AUTHORISATION_FORM: '/forms/third-party-authorisation-form.pdf',
    TRANSFER_CERTIFICATE_REQUEST_FORM: '/forms/transfer-certificate-request-form.pdf',
    TRAVEL_INSURANCE_MAKE_A_CLAIM_FORM: '/forms/ahm-travel-insurance-claim-form.pdf',
};
